import { render, staticRenderFns } from "./PaymentOptionEducation.vue?vue&type=template&id=54c0007a"
import script from "./PaymentOptionEducation.vue?vue&type=script&lang=ts"
export * from "./PaymentOptionEducation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports